import { Component, Input, OnInit } from '@angular/core'
import { EksClusterAccessDeniedIssue } from 'src/app/account/services/issue'
import { UiService } from 'src/app/services/ui.service'
import { CopyFeedbackService } from 'src/app/shared/copy-feedback.service'

@Component({
  selector: 'eks-cluster-permission-issue',
  templateUrl: './eks-cluster-permission-issue.component.html',
  styleUrls: ['./eks-cluster-permission-issue.component.scss'],
  standalone: false,
  providers: [CopyFeedbackService],
})
export class EksClusterPermissionIssueComponent implements OnInit {
  @Input() issue: EksClusterAccessDeniedIssue = null

  constructor(
    public uiService: UiService,
    public copyFeedback: CopyFeedbackService
  ) {}

  ngOnInit() {}

  get commandToRun() {
    return (
      `eksctl create iamidentitymapping ` +
      `--cluster ${this.issue.clusterName} ` +
      `--region=${this.issue.region} ` +
      `--arn ${this.issue.delegateRoleArn} ` +
      `--username ${this.uiService.productName} ` +
      `--group system:masters --no-duplicate-arns`
    )
  }

  get accessEntryCommandToRun() {
    return (
      `aws eks create-access-entry ` +
      `--region=${this.issue.region} ` +
      `--cluster-name ${this.issue.clusterName} ` +
      `--principal-arn ${this.issue.delegateRoleArn} ` +
      `--type STANDARD --user ${this.uiService.productName} ; ` +
      `aws eks associate-access-policy ` +
      `--region=${this.issue.region} ` +
      `--cluster-name ${this.issue.clusterName} ` +
      `--principal-arn ${this.issue.delegateRoleArn} ` +
      `--policy-arn arn:aws:eks::aws:cluster-access-policy/AmazonEKSAdminViewPolicy ` +
      `--access-scope type=cluster`
    )
  }
}
